import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import EditAndDelete from './EditAndDelete';

const EditAndDeleteCollection: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Select Company',
            content: <GetInfo apiLink='companies/getOneCompany/' isAllCompanies/>,
            id: 0,
        },

        {
            title: 'Edit and Delete Collection',
            content: <EditAndDelete />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};
 
export default EditAndDeleteCollection;
